module.exports = __webpack_public_path__ + "img/c2.e4f9c2ee.png";